import React, { useRef } from 'react';
import './VideoLinkField.css';

export const DESTINATION_ARTICLES = 'articles';
export const DESTINATION_VIDEOS = 'videos';

const OPTIONS = [
    { value: DESTINATION_ARTICLES, label: 'Articles' },
    { value: DESTINATION_VIDEOS, label: '▶ Condoned Media — Videos page' },
];

// Arrow keys move the choice, as in any radio group.
const ARROW_STEPS = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };

// One-click choice of where a document is listed: the article listing on
// the front page, or the Condoned Media videos page (/videos).
function PublishDestination({ value, onChange, disabled = false, hint }) {
    const optionRefs = useRef([]);
    // Roving tab stop: Tab reaches the group once, on the chosen option.
    const tabStop = Math.max(0, OPTIONS.findIndex((option) => option.value === value));

    const handleKeyDown = (event, index) => {
        const step = ARROW_STEPS[event.key];
        if (!step) {
            return;
        }
        event.preventDefault();
        const nextIndex = (index + step + OPTIONS.length) % OPTIONS.length;
        onChange(OPTIONS[nextIndex].value);
        optionRefs.current[nextIndex]?.focus();
    };

    return (
        <div className="publish-destination" role="radiogroup" aria-label="Publish to">
            <span className="publish-destination__label" aria-hidden="true">Publish to</span>
            <div className="publish-destination__options">
                {OPTIONS.map((option, index) => {
                    const selected = value === option.value;
                    return (
                        <button
                            key={option.value}
                            ref={(element) => {
                                optionRefs.current[index] = element;
                            }}
                            type="button"
                            role="radio"
                            aria-checked={selected ? 'true' : 'false'}
                            tabIndex={index === tabStop ? 0 : -1}
                            onKeyDown={(event) => handleKeyDown(event, index)}
                            className={`publish-destination__option publish-destination__option--${option.value}${selected ? ' is-selected' : ''}`}
                            onClick={() => onChange(option.value)}
                            disabled={disabled}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
            {hint && <small>{hint}</small>}
        </div>
    );
}

export default PublishDestination;
